import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, TextField, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import clientsSx from './Clients.styles';
import { actions } from './Clients.redux';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Search } from '@mui/icons-material';

const ClientSearch = () => {
    const theme = useTheme();
    const sx = clientsSx(theme);
    const dispatch = useDispatch();
    const searchTerms = useSelector((state) => state.clients.searchTerms);
    const loading = useSelector((state) => state.clients.loading);
    const setSearchTerm = (key, value) => dispatch(actions.setSearchTerm(key, value));
    const handleSearch = () => dispatch(actions.search());
    const resetSearch = () => dispatch(actions.resetSearch());

    const handleChange = (e) => setSearchTerm(e.target.name, e.target.value);

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSearch();
    };

    return (
        <Box sx={sx.searchContainer}>
            <DashboardCard
                color={'deepOrange'}
                icon={<Search />}
                topContent={'Client Search'}
                topLabel="Enter search criteria below"
                size="xl"
            >
                <form method="post" onSubmit={handleSubmit}>
                    <Grid container spacing={4}>
                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                label="Client Name"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.client_name}
                                name="client_name"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                label="External ID"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.client_external_id}
                                name="client_external_id"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                label="City"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.address_city}
                                name="address_city"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                label="State"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.address_state}
                                name="address_state"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                type="date"
                                label="Last Visit (Start)"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="outlined"
                                fullWidth
                                value={searchTerms.last_visit_start}
                                name="last_visit_start"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                type="date"
                                label="Last Visit (End)"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="outlined"
                                fullWidth
                                value={searchTerms.last_visit_end}
                                name="last_visit_end"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={handleSearch}
                                sx={sx.searchButtons}
                                disabled={loading}
                                type="submit"
                            >
                                Search
                            </Button>

                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                                onClick={resetSearch}
                                sx={sx.searchButtons}
                                disabled={loading}
                            >
                                Reset
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </DashboardCard>
        </Box>
    );
};

export default ClientSearch;
